import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { data } from "../firebase/firebese";
import { toast } from 'react-toastify';
import Loader from "../components/Loader";
import AdminCart from "../components/admin/adminCart";

export default function Admin(){
    const [checking, setChecking] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                toast.error("يرجى تسجيل الدخول أولاً!");
                navigate("/auth");
                return;
            }
            const userDoc = await getDoc(doc(data, "authentact", user.uid));
            if (!userDoc.exists() || userDoc.data().isAdmain !== true) {
                toast.error("ليس لديك صلاحية للوصول لهذه الصفحة!");
                navigate("/");
                return;
            }
            setChecking(false);
        });
        return () => unsubscribe();
    }, [navigate]);

    if (checking) return <Loader />;

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-center align-items-center py-3">
                    </div>
                    
                    <AdminCart />
                </div>
            </div>
        </div>
    );
}